import { createSlice } from "@reduxjs/toolkit";
import { PayloadAction } from "@reduxjs/toolkit";
import { message } from "antd";
import API from "../../api"
const {homePageList,homePageAdd,homePageUpdate,homePageDelete,homePageEdit}=API

const initialState = { 
    data:[],
    singleHomePage:[],
    error: null, 
    loading:false,
    message:'',
    deleteLoad:false,
    editData:[]
}

const homePageSlice = createSlice({
    name: "homePage",
    initialState,
    reducers: {
      setData(state,action){
          state.data=action.payload;
      },
      setLoading(state, action) {
          state.loading = action.payload;
        },
      setMessage(state,action){
          state.message=action.payload;
      },
      setError(state,action){
          state.error=action.payload;
    },
      setDeleteLoad(state,action){
          state.deleteLoad=action.payload
      },
      setAfterDeleteHomePage(state,action){
          state.data=state.data.filter((item)=>item._id !== action.payload)
      },
      setHomePageAdd(state,action){
          state.data=[action.payload,...state.data]
      },
      setEditHomePage(state,action){
          state.singleHomePage=state.data.filter((item)=>item._id === action.payload)
      },
      setBlankSingleData(state,action){
        state.singleHomePage=[]
      },
      setEditData(state,action){
        state.editData=action.payload
    }
    },
  });
  
  export const {setEditData, setLoading, setMessage,setError,setData,setDeleteLoad,setHomePageAdd,setAfterDeleteHomePage,setEditHomePage,setBlankSingleData} = homePageSlice.actions;
  export default homePageSlice.reducer;

  export const getHomePageData = () => async (dispatch) => {
         dispatch(setLoading(true));
    try {
      const res= await homePageList()
      if (res.data.success) {
          dispatch(setData(res.data.data[0]?.fieldvalue))
          dispatch(setLoading(false));
          dispatch(setMessage(res.data.message))
      } else {
          dispatch(setLoading(false));
          dispatch(setError(res.data.message));
      }
    } catch (e){
      dispatch(setLoading(false));
      dispatch(setError(e.message));
      message.error(e.message);
    }
  };
  export const homePageDataAdded=(data) => async (dispatch)=>{
    dispatch(setDeleteLoad(true));
    try{
      const res= await homePageAdd(data)
      if(res.data.success) {
         dispatch(setHomePageAdd(data))
         dispatch(setDeleteLoad(false))
         dispatch(setMessage(res.data.message))
         message.success(res.data?.message);
      } else {
        dispatch(setDeleteLoad(false));
        dispatch(setError(res.data.message));
        message.error(res.data.message);
    }
    } catch(e){
      dispatch(setDeleteLoad(false));
      dispatch(setError(e.response.data.message));
      message.error(e.response.data.message);
    }
}

export const sigleHomePageDataAction=(id) =>(dispatch)=>{
              dispatch(setEditHomePage(id))
}

export const homePageDataUpdate=(id,data) => async (dispatch)=>{
  dispatch(setDeleteLoad(true));
  try{
    const res= await homePageUpdate(id,data)
    if(res.data.success) {
       dispatch(setBlankSingleData())
       dispatch(setEditData())
       dispatch(setDeleteLoad(false))
       dispatch(setMessage(res.data.message))
       message.success(res.data?.message);
    } else {
      dispatch(setDeleteLoad(false));
      dispatch(setError(res.data.message));
      message.error(res.data.message);
  }
  } catch(e){
    dispatch(setDeleteLoad(false));
    dispatch(setError(e.response.data.message));
    message.error(e.response.data.message);
  }
}
export const homePageEditAction=(id,field) => async (dispatch)=>{
  try{
    const res= await homePageEdit(id,field)
    if(res.data.success) {
       dispatch(setEditData(res.data.data))
    } else {
      message.error(res.data.message);
  }
  } catch(e){
    message.error(e.response.data.message);
  }
}
export const editBlankData=() =>(dispatch)=>{
        dispatch(setEditData())
}
  export const homePageDataDelete=(id) => async (dispatch)=>{
          dispatch(setDeleteLoad(true));
          try{
            const res= await homePageDelete(id)
            if(res.data.success) {
               dispatch(setAfterDeleteHomePage(id))
               dispatch(setDeleteLoad(false))
               dispatch(setMessage(res.data.message))
               message.success(res.data?.message);
            } else {
              dispatch(setDeleteLoad(false));
              dispatch(setError(res.data.message));
              message.error(res.data.message);
          }
          } catch(e){
            dispatch(setDeleteLoad(false));
            dispatch(setError(e.response.data.message));
            message.error(e.response.data.message);
          }
  }